export function isLocalDevelopment() {
  return window.location.protocol !== 'https:';
}
